import script from "./NavBarList.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarList.vue?vue&type=script&setup=true&lang=js"

import "./NavBarList.vue?vue&type=style&index=0&id=3a5eb8e1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5eb8e1"]])

export default __exports__